import { render, staticRenderFns } from "./menudetails.vue?vue&type=template&id=a48ad4cc&scoped=true&"
import script from "./menudetails.vue?vue&type=script&lang=js&"
export * from "./menudetails.vue?vue&type=script&lang=js&"
import style0 from "./menudetails.vue?vue&type=style&index=0&id=a48ad4cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48ad4cc",
  null
  
)

export default component.exports